import { RecentlyViewed } from '@theme/recently-viewed-products';

const MAX_PRODUCTS = 4;

class VallonRecentlyViewed extends HTMLElement {
  #controller;

  #observer = new MutationObserver(() => {
    if (!this.hidden || !this.isConnected) return;
    this.#refresh();
  });

  connectedCallback() {
    this.#observer.disconnect();
    this.hidden = true;
    this.#observer.observe(this, { attributes: true, attributeFilter: ['hidden'] });
    this.#refresh();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#observer.disconnect();
  }

  #refresh() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#load(this.#controller.signal);
  }

  async #load(signal) {
    let viewedProducts;

    try {
      viewedProducts = RecentlyViewed.getProducts();
    } catch {
      return;
    }

    if (!Array.isArray(viewedProducts)) return;

    const currentProductId = this.dataset.currentProductId;
    const productIds = [...new Set(viewedProducts.map(String))]
      .filter((id) => /^\d+$/.test(id) && id !== currentProductId)
      .slice(0, MAX_PRODUCTS);

    if (productIds.length === 0 || !this.dataset.searchUrl) return;

    const url = new URL(this.dataset.searchUrl, window.location.origin);
    url.searchParams.set('section_id', 'vallon-recently-viewed');
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    try {
      const response = await fetch(url, { headers: { Accept: 'text/html' }, signal });
      if (!response.ok) return;

      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = document.querySelector('[data-recently-viewed-content]');

      if (!content?.querySelector('[data-recent-product-card]') || signal.aborted || !this.isConnected) return;

      this.replaceChildren(content.cloneNode(true));
      this.hidden = false;
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return;
    }
  }
}

if (!customElements.get('vallon-recently-viewed')) {
  customElements.define('vallon-recently-viewed', VallonRecentlyViewed);
}
